module.exports = __webpack_public_path__ + "static/fresh-aa8889d6156ed2ae55b6bc7eb9c3217a.svg";